/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Category_Sort_PopularInputs */

const en_directory_category_sort_popular = /** @type {(inputs: Directory_Category_Sort_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular`)
};

const zh_directory_category_sort_popular = /** @type {(inputs: Directory_Category_Sort_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门`)
};

/**
* | output |
* | --- |
* | "Popular" |
*
* @param {Directory_Category_Sort_PopularInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_category_sort_popular = /** @type {((inputs?: Directory_Category_Sort_PopularInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Category_Sort_PopularInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_category_sort_popular(inputs)
	return zh_directory_category_sort_popular(inputs)
});
export { directory_category_sort_popular as "directory.category.sort_popular" }